import React, { useEffect, useState } from "react";
import qs from "qs";
import { history } from "common/history";
import Loader from "../../components/Loader";
import { ncsDecryptParams, ncsUserExistsInSystem } from "api";

const NCSRedirectHandler = () => {
  const [loading, setLoading] = useState(true);

const checkUser = async () => {
  const query = window.location.search.substring(1);
  const params = qs.parse(query);

  try {
    const responseData = await ncsDecryptParams({
      ...params,
      original_link: window.location.href
    });
    const decryptedData = responseData?.data || {};

    const email = decryptedData.email;

    if (email) {
      localStorage.setItem("ncsEmail", email);
    }

    const result = await ncsUserExistsInSystem(email);
    const userData = result?.data;
    const userExist = userData?.email ?? false;

    if (userExist) {
      if (userData?.provider === "ncs") {
        history.push({
          pathname: "/ncs-login",
          state: { email }
        });
      } else {
        history.push({ pathname: "/signin" });
      }
    } else {
      history.push({
        pathname: "/ncs-register",
        state: { prefillData: decryptedData }
      });
    }
  } catch (error) {
    console.log("API call failed:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    checkUser();
  }, []);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }}>
      <Loader visible={loading} />
    </div>
  );
};

export default NCSRedirectHandler;
